export const ADD_TO_BETSLIP = 'luckyDipBetslip/ADD_TO_BETSLIP';
export const RESET_BETSLIP = 'luckyDipBetslip/RESET_BETSLIP';
export const SET_STAKE = 'luckyDipBetslip/SET_STAKE';
export const BETSLIP_SUBMIT_INIT = 'luckyDipBetslip/BETSLIP_SUBMIT_INIT';
export const BETSLIP_SUBMIT_COMPLETE = 'luckyDipBetslip/BETSLIP_SUBMIT_COMPLETE';
export const TOGGLE_USE_PROMO_CASH = 'luckyDipBetslip/TOGGLE_USE_PROMO_CASH';
